import { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from 'react';
import cx from 'clsx';
import styles from './Button.module.css';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    variant?: 'default' | 'outlined' | 'text';
    compact?: boolean;
    as?: 'a' | 'button';
    grow?: boolean;
  };

export const Button: FC<ButtonProps> = ({
  className,
  variant = 'default',
  as = 'button',
  compact,
  grow,
  ...props
}) => {
  const Component = as;
  return (
    <Component
      className={cx(
        styles.btn,
        {
          [styles.outlined]: variant === 'outlined',
          [styles.text]: variant === 'text',
          [styles.compact]: compact,
          [styles.disabled]: as === 'a' && props.disabled,
          [styles.grow]: grow,
        },
        className
      )}
      {...props}
    />
  );
};
